import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "flex items-center justify-center  whitespace-nowrap   disabled:pointer-events-none disabled:opacity-50 mx-auto",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        primaryBtn:
          "block mt-auto bg-[#0077C8] hover:bg-[#068EEB] text-white text-center py-mob-14 sm:py-tab-14 lg:py-web-18 !text-mob-15 sm:!text-tab-15 lg:!text-web-15 leading-[100%] font-medium  rounded-mob-6 sm:rounded-tab-6 lg:rounded-web-6 uppercase tracking-[0.69vw] sm:tracking-[0.39vw] lg:tracking-[0.156vw] transition-all ease cursor-pointer w-full",
        primaryOutLineBtn:
          "block mt-auto text-center py-mob-14 sm:py-tab-14 lg:py-web-18 !text-mob-15 sm:!text-tab-15 lg:!text-web-15 leading-[100%] font-medium text-PrimaryLightBlue border border-PrimaryLightBlue rounded-mob-6 sm:rounded-tab-6 lg:rounded-web-6 uppercase tracking-[0.69vw] sm:tracking-[0.39vw] lg:tracking-[0.156vw] hover:bg-SecondaryYellow hover:border-SecondaryYellow transition-all ease cursor-pointer w-full",
        secondaryLinkBtnBlue:
          "flex items-center gap-mob-10 sm:gap-tab-10 lg:gap-web-10 uppercase justify-center text-PrimaryLightBlue !text-mob-15 sm:!text-tab-15 lg:!text-web-15 font-medium leading-mob-18 sm:leading-tab-18 lg:leading-web-18 tracking-[1.046vw] sm:tracking-[0.58vw] lg:tracking-[0.234vw] py-mob-4 sm:py-tab-4 lg:py-web-4 px-mob-20 sm:px-tab-20 lg:px-web-20 rounded-mob-15 sm:rounded-tab-15 lg:rounded-web-15 hover:bg-SecondaryYellow",
      },
      size: {
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        arrowIcon: "w-mob-7 sm:w-tab-7 lg:w-web-7",
      },
    },
    defaultVariants: {},
  }
);



export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}


const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  // ({ className, variant, size, asChild = false, ...props }, ref) => {
  ({ className, variant, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        // className={cn(buttonVariants({ variant, size, className }))}
        className={cn(buttonVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
